<template>
  <div class="product-bottom-badges">
    <div
      v-for="(item, i) in data"
      :key="i"
      class="product-bottom-badges__wrap"
      :class="{'product-bottom-badges__wrap--icon': item.image, 'product-bottom-badges__wrap--text': item.text}"
      :style="{'background-color': '#' + item.bg_color, 'color': '#' + item.bg_color}"
    >
      <img class="product-bottom-badges__icon"
           v-if="item.image"
           :src="item.image"
           alt="icon">
      <span class="product-bottom-badges__text" v-else-if="item.text" :style="{'color': '#' + item.text_color}">{{ item.text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductBottomBadges',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="sass">
.product-bottom-badges
  display: flex
  flex-flow: row

.product-bottom-badges__wrap
  display: flex
  justify-content: center
  align-items: center
  position: relative

.product-bottom-badges__wrap--icon
  margin-right: 28px
  padding: 4px 0 4px 2.5px

  +mmin(385)
    padding: 4px 5px 4px 10px

.product-bottom-badges__wrap--text
  padding: 4px 7px 4px 0
  white-space: nowrap

  +mmin(385)
    padding: 4px 14px 4px 7px

.product-bottom-badges__wrap--icon:before
  position: absolute
  content: ''
  width: 30px
  top: 0
  bottom: 0
  right: -11px
  background-color: currentColor
  transform: skewX(45deg)

.product-bottom-badges__wrap--text:before
  position: absolute
  content: ''
  width: 30px
  top: 0
  bottom: 0
  left: -11px
  background-color: currentColor
  transform: skewX(45deg)

.product-bottom-badges__icon
  display: block
  z-index: 0

.product-bottom-badges__text
  display: block
  z-index: 0
  color: #fff
  font-size: 10px
  font-weight: 500
  text-transform: uppercase

  +mmin(385)
    font-size: 12px

</style>
